import { getAppState } from "../state";
import { isUserAccountActive } from "../services/accountStatusService";
import { routes } from "../routes";

const ADDONS_LAYOUTS_RELATIVE_PATH = "/brands/";
const DEFAULT_LANDING_PATH = "home";
const excludeActiveUserRedirectPath = ["series", "movies"];
const premiumSubscriptions = ["starzplay", "starzplayultimate", "starzplaysports"];
const DEFAULT_PREMIUM_SUBSCRIPTION_LANDING = "premium";

let subscriptionFilteredList = [];

export async function setActiveUserRedirectionPath(redirectionConfig = null) {
  if (!redirectionConfig) {
    redirectionConfig = getAppState().activeUserRedirectionConfig;
    if (!redirectionConfig) return DEFAULT_LANDING_PATH;
  }
  const isUserLogged = getAppState().userLogged;
  const addons = getAppState().addons;
  const userAccountStatus = getAppState().userAccountStatus;
  const userAddonStatus = getAppState()?.userAddonStatus;
  const landing = redirectionConfig?.landing || {};
  const priorities =
    (redirectionConfig && redirectionConfig?.priorities && redirectionConfig?.priorities.split(",")) || [];

  let userActiveSubscription = null;
  //Filtering subcsription list to avoid isCustomAddon = true case to avoid NBA on bigcsreen side redirection
  const subscriptionList =
    (getAppState().subscriptions && getAppState().subscriptions?.filter(data => !data?.configuration.isCustomAddon)) ||
    [];
  subscriptionFilteredList = subscriptionList;

  if (isUserLogged && (isUserAccountActive(userAccountStatus) || userAddonStatus)) {
    if (!subscriptionList || (subscriptionList && Object.keys(subscriptionList).length === 0)) {
      return DEFAULT_LANDING_PATH;
    }
    const activeUserAddons = addons.filter(addon => addon.status.toLowerCase() === "active").map(addon => addon.name);

    // Filter active addons based on availability in SC list
    const activeAddons = await filterAddonsByAvailability(activeUserAddons);

    isUserAccountActive(userAccountStatus) && activeAddons.push("starzplay");

    if (!activeAddons || (activeAddons && Object.keys(activeAddons).length === 0)) {
      return DEFAULT_LANDING_PATH;
    }
    if (activeAddons && activeAddons.length < 2) {
      userActiveSubscription = activeAddons[0];
    } else {
      if (!priorities || (priorities && priorities.length === 0) || (priorities && priorities[0] === "")) {
        return DEFAULT_LANDING_PATH;
      }

      const { index, value: FilteredSubscriptionFromPriority } = await findTopPrioritySubscriptionIndexKeyAndValue(
        priorities,
        activeAddons
      );

      if (!FilteredSubscriptionFromPriority) {
        return DEFAULT_LANDING_PATH;
      }

      userActiveSubscription = FilteredSubscriptionFromPriority;
    }
  }
  if (userActiveSubscription) {
    const activeUserRedirectRoute = await getRedirectRouteFromLandingConfig(landing, userActiveSubscription);
    return activeUserRedirectRoute === DEFAULT_PREMIUM_SUBSCRIPTION_LANDING
      ? DEFAULT_LANDING_PATH
      : activeUserRedirectRoute;
  } else {
    return DEFAULT_LANDING_PATH; // this case  is pending
  }
}

const findTopPrioritySubscriptionIndexKeyAndValue = async (priorities, activeAddons) => {
  let leastIndex = -1;
  let leastValue = null;
  for (const addon of activeAddons) {
    if (priorities && priorities.includes(addon)) {
      const priorityIndex = priorities.indexOf(addon);
      if (leastIndex === -1 || priorityIndex < leastIndex) {
        leastIndex = priorityIndex;
        leastValue = addon;
      }
    }
  }

  return { index: leastIndex, value: leastValue };
};

const getRedirectRouteFromLandingConfig = async (landing, userActiveSubscription) => {
  if (landing && Object.keys(landing).length > 0) {
    // landing object present cases
    if (userActiveSubscription in landing) {
      const mainPackage = await isUnderMainPackage(userActiveSubscription);
      if (!mainPackage) {
        return `${ADDONS_LAYOUTS_RELATIVE_PATH}${landing[userActiveSubscription]}`;
      } else {
        const isAddonName = await getAddOnByName(landing[userActiveSubscription]);
        return isAddonName
          ? `${ADDONS_LAYOUTS_RELATIVE_PATH}${landing[userActiveSubscription]}`
          : landing[userActiveSubscription];
      }
    } else {
      const mainPackage = await isUnderMainPackage(userActiveSubscription);
      return !mainPackage
        ? `${ADDONS_LAYOUTS_RELATIVE_PATH}${userActiveSubscription}`
        : premiumSubscriptions.includes(userActiveSubscription)
        ? DEFAULT_PREMIUM_SUBSCRIPTION_LANDING
        : DEFAULT_LANDING_PATH;
    }
  } else {
    // empty landing object
    const mainPackage = await isUnderMainPackage(userActiveSubscription);
    return !mainPackage
      ? `${ADDONS_LAYOUTS_RELATIVE_PATH}${userActiveSubscription}`
      : premiumSubscriptions.includes(userActiveSubscription)
      ? DEFAULT_PREMIUM_SUBSCRIPTION_LANDING
      : DEFAULT_LANDING_PATH;
  }
};

const isUnderMainPackage = async addon => {
  const addons = await getAddOnByName(addon);
  return addons?.configuration?.isMainPackage || false;
};

export async function getAddOnByName(addOnName) {
  const addOnsList = subscriptionFilteredList?.filter(data => data?.name === addOnName) || [];
  if (addOnsList?.length > 0) {
    return addOnsList[0];
  }
  return null;
}

export const getActiveUserLandingRoutePath = path => {
  if (path && path.includes(ADDONS_LAYOUTS_RELATIVE_PATH)) {
    return path;
  }
  return routes[path];
};

export const isFromContentDetailsPath = redirectPath => {
  const containsExcludedPath = excludeActiveUserRedirectPath.some(path => redirectPath.includes(`/${path}/`));
  return containsExcludedPath;
};

const isAvailableInSCList = async addon => {
  try {
    const addons = await getAddOnByName(addon);
    return addons ? true : false;
  } catch (error) {
    return false;
  }
};

const filterAddonsByAvailability = async addons => {
  const availableAddons = [];
  for (const addon of addons) {
    const isAvailable = await isAvailableInSCList(addon);
    if (isAvailable) {
      availableAddons.push(addon);
    }
  }
  return availableAddons;
};
